<mat-slide-toggle
    *ngIf="showReceiptButton"
    labelPosition="before"
    [disableRipple]="true"
    [(ngModel)]="isReceiptEnabled"
    [ngClass]="cssClass">
    {{ slideToggleText | translate }}
</mat-slide-toggle>
